
<template>
  <div>
    <v-dialog v-model="dialog" width="520px" persistent>
      <v-card class="resume-dialog-card">
        <div class="resume-dialog-header d-flex align-center px-5 py-4">
          <v-avatar color="white" size="36" class="mr-3 elevation-1">
            <v-icon color="blue-grey darken-2">mdi-clipboard-check-outline</v-icon>
          </v-avatar>
          <div class="title white--text">Resumo do pagamento</div>
        </div>
        <v-card-text class="pt-4 px-0">
          <v-row dense class="mx-3 mb-2">
            <v-col :cols="summaryCols">
              <div class="resume-summary-card">
                <div class="caption grey--text text--darken-1">Valor do pagamento</div>
                <div class="subtitle-1 font-weight-bold success--text text--darken-1">{{ formatCurrency(payment_ammount) }}</div>
              </div>
            </v-col>
            <v-col :cols="summaryCols" v-if="total_juros > 0">
              <div class="resume-summary-card">
                <div class="caption grey--text text--darken-1">Juros</div>
                <div class="subtitle-1 font-weight-bold warning--text text--darken-1">{{ formatCurrency(total_juros) }}</div>
              </div>
            </v-col>
            <v-col :cols="summaryCols" v-if="add_bonus">
              <div class="resume-summary-card">
                <div class="caption grey--text text--darken-1">Bônus sendo adicionado</div>
                <div class="subtitle-1 font-weight-bold">{{ formatCurrency(bonus_ammount) }}</div>
              </div>
            </v-col>
          </v-row>
          <v-divider class="my-1"></v-divider>
          <v-sheet class="ml-4" style="overflow-y: auto; max-height: 50vh">
            <template v-if="selected_vrts.length > 0">
              <span v-if="add_bonus">Faturas sendo pagas:</span>
              <v-list>
                <v-list-item-group >
                  <v-list-item v-for="vrt in selected_vrts" :key="vrt.id">
                    <v-list-item-icon> <v-icon>{{text_map(vrt).icon}}</v-icon> </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title class="text-wrap">
                        <span v-if="!add_bonus">{{vrt.attributes.comment}}</span>
                        <span v-if="add_bonus"><b :class="text_map(vrt).class">( {{text_map(vrt).text}} )</b> {{vrt.attributes.comment}}</span>
                      </v-list-item-title>
                      <v-list-item-subtitle class="d-flex flex-column"> 
                        <span v-if="add_bonus">
                          <b>Valor base: {{formatCurrency(payingAmmount(vrt))}}</b>
                        </span>
                        <span v-if="add_bonus && payingJuros(vrt) > 0">
                          Juros: <b class="warning--text text--darken-1">{{formatCurrency(payingJuros(vrt))}}</b>
                        </span>
                        <span v-if="add_bonus && payingJuros(vrt) > 0">
                          Total na fatura: <b>{{formatCurrency(payingTotal(vrt))}}</b>
                        </span>
                        <span v-if="!add_bonus">
                          <b>
                            Valor a ser pago: {{formatCurrency(payingAmmount(vrt))}}
                          </b>
                        </span>
                        <span v-if="!add_bonus && payingJuros(vrt) > 0">
                          Juros: <b class="warning--text text--darken-1">{{formatCurrency(payingJuros(vrt))}}</b>
                        </span>
                        <span v-if="!add_bonus && payingJuros(vrt) > 0">
                          Total: <b>{{formatCurrency(payingTotal(vrt))}}</b>
                        </span>
                        <span v-if="add_bonus">
                          Valor restante: <b>{{formatCurrency(rest_ammount(vrt))}}</b>
                        </span>
                      
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </template>
            <template v-if="selected_vrts.length == 0">
              <div class="d-flex flex-column justify-center text-center ma-2">
                <span>
                  Nenhuma fatura sendo paga!
                </span>
                <span>
                  O valor do pagamento inteiro será <b>convertido em bônus!</b>
                </span>
              </div>
            </template>
          </v-sheet>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn text @click="dialog = !dialog">Voltar</v-btn>
          <v-btn @click="submitPayment" :disabled="zero_payment" color="primary" depressed class="px-5">
            <v-icon left small>mdi-cash-fast</v-icon>
            <span v-if="!wait_client_payment">Pagar</span>
            <span v-if="wait_client_payment">Continuar</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

export default {
  name: 'DialogResumePayment',
  props: {
    selected_vrts: {
      type: Array,
      default: () => []
    },
    payment_ammount:{
      type: [String, Number],
      default: "0.00",
    },
    bonus_ammount: {
      type: [String, Number],
      default: "0.00",
    },
    add_bonus:{
      type: Boolean,
      default: true
    },
    wait_client_payment: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialog: false,
    }
  },
  computed: {
    zero_payment(){
      return Number(this.payment_ammount) == 0 
    },
    total_juros(){
      return this.selected_vrts.reduce((sum, vrt) => sum + this.payingJuros(vrt), 0)
    },
    summaryCols(){
      const cards = 1 + (this.total_juros > 0 ? 1 : 0) + (this.add_bonus ? 1 : 0)
      return 12 / cards
    },
  },
  methods: {
    formatCurrency(value){
      return Number(value).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
    },
    payingAmmount(vrt){
      return Number(vrt.paying_ammount?.toString()?.replace(/,/g, '') || 0)
    },
    payingJuros(vrt){
      return Number(vrt.paying_juros?.toString()?.replace(/,/g, '') || 0)
    },
    payingTotal(vrt){
      return this.payingAmmount(vrt) + this.payingJuros(vrt)
    },
    openDialog(){
      this.dialog = true
    },
    text_map(vrt){
      if(this.rest_ammount(vrt) == 0){
        return {
          text: "Totalmente paga",
          icon: "mdi-check",
          class: "success--text"
        }
      }else{
        return {
          text: "Parcialmente pago",
          icon: "mdi-list-status",
          class: "warning--text"
        }
      }
    },
    rest_ammount(vrt){
      if(vrt.paying_ammount){
        return ( Number(vrt.attributes.ammount) - Number(vrt.attributes.ammount_payed)).toFixed(2) - this.payingAmmount(vrt)
      }else{
        return 0
      }
    },
    submitPayment(){
      this.$emit("submitPayment")
    }
  },

}
</script>

<style scoped>
.resume-dialog-card {
  border-radius: 16px !important;
  overflow: hidden;
}
.resume-dialog-header {
  background: linear-gradient(135deg, #263238 0%, #455a64 55%, #78909c 100%);
}
.resume-summary-card {
  background: #f7f9fb;
  border: 1px solid #e8eef3;
  border-radius: 12px;
  padding: 10px 12px;
  height: 100%;
}
</style>